export default __webpack_public_path__ + "47e9ba113dd9c806f7d2294d8ba7e5af.png";